<template>
  <div class="dashboard--root">
    
    <div class="">
    <div class="ui visible inverted left vertical sidebar menu">
      <img class="ui small image user--image" :src="userData.avatar_url">
      
      <h2 class="user--name">
        {{ userData.first_name }} {{ userData.last_name }}
      </h2>

      <router-link class="item" to="/dashboard">
        <i class="home icon"></i>
        Home
      </router-link>
      <router-link class="item" to="/dashboard/orgs">
        <i class="building outline icon"></i>
        My Organizations
      </router-link>
      <router-link class="item" to="/dashboard/events">
        <i class="calendar alternate outline icon"></i>
        My Events
      </router-link>
      <router-link class="item" to="/dashboard/courses">
        <i class="laptop icon"></i>
        My Courses
      </router-link>
      <router-link class="item" to="/dashboard/user-profile">
        <i class="sliders horizontal icon"></i>
        Settings
      </router-link>
      <a class="item" @click="logout">
        <i class="sign out alternate icon"></i>
        Logout
      </a>
    </div>
    <div class="pusher dashboard--content">
      <div class="ui basic segment">
        <p class="ui text">
          Hello {{ userData.first_name }},
        </p>
        <h2 class="dashboard--title ui header">
          Welcome to Sudan Crisis Coordination Unit (SCCU) dashboard.
        </h2>
        <p></p>
        <p></p>
        <p></p>
        <p></p>

        <transition name="fade"
          mode="out-in">
          <router-view></router-view>
        </transition>
      </div>
    </div>
  </div>
      
  </div>
</template>

<script>
export default {
  name: 'UserProfile',
  data() {
    return {
      userData: {}
    };
  },
  async created() {
    await this.fetchUserData();
  },
  methods: {
    async fetchUserData() {
      try {
        const response = await fetch('/wp-json/custom/v1/user?k__sjnb__sdfjn0547=' + localStorage.getItem('sjdifjsckdsjfosdf54520zzz') + ''
          , {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            credentials: 'same-origin',
            'user-id': localStorage.getItem('sjdifjsckdsjfosdf54520zzz'),
            'email': 'hello@men3m.com'
          }
        });

        const responseData = await response.json(); // Parse the JSON response

        if (response.ok && responseData.success) {
          this.userData = responseData.userr;
        } else {
          console.error('Failed to fetch user data:', responseData);
        }
      } catch (error) {
        console.error('An error occurred:', error);
      }
    },
    logout() {
      localStorage.removeItem('sjdifjsckdsjfosdf54520zzz');
      localStorage.removeItem('sjdifjsckdsjfosdf54520yyy');
      localStorage.removeItem('sjdifjsckdsjfosdf54520bearer');
      fetch('/wp-json/custom/v1/logout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          credentials: 'same-origin'
        }
      });
      // redirect window to login page
      window.location.href = '/user/#/login';
    }
  }
};
</script>


<style lang="sass">
  @import '../assets/css/public'

  .dashboard--root
    min-height: 100vh

  .sidebar
    padding-top: 50px
    background: $sec-purple !important

    .item
      font-size: 18px !important

    .user--image
      margin: 0 auto
      display: block
      margin-bottom: 20px
      margin-bottom: 20px
      border: 4px solid $white

    .user--name
      text-align: center
      color: $white
      font-size: 20px
      font-weight: normal

  .dashboard--content
    width: 80%

</style>